import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, API, storeToken } from '../App';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session token
        const response = await fetch(`${API}/auth/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          throw new Error('Failed to authenticate');
        }

        const userData = await response.json();
        
        // Store token in localStorage for browsers blocking third-party cookies
        if (userData.token) {
          storeToken(userData.token);
        }
        
        setUser(userData);

        // Clear the hash and navigate to dashboard with user data
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user: userData } });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="flex justify-center gap-1 mb-4">
          <div className="audio-bar" style={{ animationDelay: '0s' }}></div>
          <div className="audio-bar" style={{ animationDelay: '0.1s' }}></div>
          <div className="audio-bar" style={{ animationDelay: '0.2s' }}></div>
          <div className="audio-bar" style={{ animationDelay: '0.3s' }}></div>
          <div className="audio-bar" style={{ animationDelay: '0.4s' }}></div>
        </div>
        <p className="text-white">Signing you in...</p>
      </div>
    </div>
  );
}
